import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en/translation.json";
import ar from "./locales/ar/translation.json";
import { getStoredLanguage } from "./languageStorage";

const initialLanguage = getStoredLanguage();

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        ar: { translation: ar },
    },
    lng: initialLanguage,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    returnEmptyString: false,
    returnNull: false,
});

export default i18n;

